import filterQueryBuilder from 'helpers/filterToQuery'
import { requests, mainApiRoot } from './index'

export const Domains = {
  all: () => requests.get(mainApiRoot, '/domains'),
  get: (id, filters = {}) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}${query}`)
  },
  del: id => requests.del(mainApiRoot, `/domains/${id}`),
  create: payload => requests.post(mainApiRoot, '/domains', payload),
  update: (id, payload) => requests.put(mainApiRoot, `/domains/${id}`, payload),
  pages: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}/keywords/pages/pages_new${query}`)
  },
  pagesChanges: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}/keywords/pages/changes${query}`)
  },
  grossing: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}/keywords/grossing${query}`)
  },
  discovery: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}/keywords/discovery${query}`)
  },
  savingsChart: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}/keywords/savings-chart${query}`)
  },
  tags: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}/tags${query}`)
  },
  visibility: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}/visibility${query}`)
  },
  overview: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}/overview${query}`)
  },
  averagePosition: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}/average-position${query}`)
  },
  traffic: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}/traffic${query}`)
  },
  position: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}/position${query}`)
  },
  serpFeatureChart: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}/serp-feature-chart${query}`)
  },
  serpFeature: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/domains/${id}/serp-feature${query}`)
  },
  shareLink: (id, payload) => requests.post(mainApiRoot, `/domains/${id}/share`, payload)
}
